import { reaction } from 'mobx';
import { gameService } from '../gameService';
import { gameDrawer } from '../gameDrawer';
import { gameResourcesService } from '../gameResourcesService';
import { gameStore } from '../../store/gameStore';
import { gameGlobalStates } from '../../core/constants/reelConstants';
import { userInfoStore } from '../../store/userInfoStore';
import { userSettingsStore } from '../../store/userSettingsStore';
import { winBarStore } from '../../store/winBarStore';

const result = {
  matrix: [
    [1, 1, 1, 1],
    [9, 4, 4, 4],
    [5, 9, 3, 3],
    [8, 8, 9, 6],
    [1, 1, 1, 1],
  ],
  additional: {
    wins: [
      {
        symbol: 1,
        line: 1,
        count: 5,
        lineOdd: 75.0,
        lineWinAmount: 300.0,
        lineWinCoinAmount: 0.0,
      },
      {
        symbol: 1,
        line: 2,
        count: 5,
        lineOdd: 75.0,
        lineWinAmount: 300.0,
        lineWinCoinAmount: 0.0,
      },
      {
        symbol: 1,
        line: 3,
        count: 5,
        lineOdd: 75.0,
        lineWinAmount: 300.0,
        lineWinCoinAmount: 0.0,
      },
      {
        symbol: 1,
        line: 4,
        count: 5,
        lineOdd: 75.0,
        lineWinAmount: 300.0,
        lineWinCoinAmount: 0.0,
      },
    ],
    expandingWild: [0, 9, 9, 9, 0],
  },
};

class IntroService {
  isRunning = false;

  timeoutId = null;

  constructor() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.setupReactions();
  }

  setupReactions() {
    const { isShowIntro } = userSettingsStore;
    this.disposeReaction = reaction(
      () => [gameStore.winEnded, document.hidden, gameStore.gameGlobalState, isShowIntro],
      async ([winEnded, isHidden, state]) => {
        if (
          winEnded &&
          !isHidden &&
          state === gameGlobalStates.show &&
          isShowIntro &&
          this.isRunning
        ) {
          this.clearDelay();
          await this.delay(3000);
          this.spinAction();
        }
      }
    );
  }

  handleVisibilityChange = () => {
    if (!document.hidden && gameStore.winEnded) {
      gameStore.setWinEnded(false);
      gameStore.setWinEnded(true);
    }
  };

  spinAction = () => {
    if (
      !document.hidden &&
      gameStore.gameGlobalState === gameGlobalStates.show &&
      gameStore.winEnded
    ) {
      gameStore.setGameGlobalState(gameGlobalStates.waiting);
      gameDrawer.startSpinAnimation();
      gameService.handleSpinResult({
        result,
        validation: 10,
        balance: userInfoStore.userBalance,
      });
    }
  };

  startIntro() {
    if (this.isRunning) return;
    gameStore.setGameGlobalState(gameGlobalStates.show);
    this.isRunning = true;
    this.spinAction();
  }

  resetIntro() {
    winBarStore.setWinLine(null);
    this.isRunning = false;
    this.clearDelay();
    this.clearReaction();
    gameDrawer.reels.forEach((col) => {
      if (col.animation) col.animation.kill();
    });
    gameDrawer.reels.length = 0;
    gameStore.setIsSpinStart(false);
    gameStore.setIsResponseReady(false);
    gameStore.setGameGlobalState(gameGlobalStates.none);
    gameResourcesService.allLinesSpine.length = 0;
  }

  delay(ms) {
    return new Promise((resolve) => {
      this.timeoutId = setTimeout(resolve, ms);
    });
  }

  clearReaction() {
    if (this.disposeReaction) {
      this.disposeReaction();
      this.disposeReaction = null;
    }
  }

  clearDelay() {
    clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }
}

export const introService = new IntroService();
